import axios from "axios";


const server = "https://rolly-a7cx.onrender.com/app/v1"

export default axios.create({
    baseURL: server,
})